import { once } from '@ember/runloop';
import { capitalize } from '@ember/string';

import type { APIData } from 'webapp-types';

import type { Args } from 'webapp/components/custom-query/setup/wizard/api-metric-builder/step-common';
import CustomQuerySetupWizardCommonStepMetricDefinitionComponent from 'webapp/components/custom-query/setup/wizard/common/step-metric-definition';

export default class CustomQuerySetupWizardApiMetricBuilderStepMetricDefinitionComponent extends CustomQuerySetupWizardCommonStepMetricDefinitionComponent<Args> {
	getInitialQueryName(): string {
		const jsonStructure = this.args.form.jsonStructure;
		if (!jsonStructure) {
			return 'My built metric';
		}

		const rowMetric = jsonStructure.rowMetric,
			rowDimension = jsonStructure.rowDimension;

		const formatKey = (key: string): string => {
			// remove backticks that might have been added
			// (see pathChunk escaping in JSONStructureRow::parseRow)
			return capitalize(key.replace(/`/g, ''));
		};

		const metricPropKey = rowMetric?.pathChunks[rowMetric.pathChunks.length - 1] || 'unknown';
		let text = formatKey(metricPropKey);
		if (rowDimension) {
			const dimensionPropKey = rowDimension.pathChunks[rowDimension.pathChunks.length - 1];
			if (dimensionPropKey) {
				text += ` by ${formatKey(dimensionPropKey)}`;
			}
		}

		return text;
	}

	// ---- start stuff for QueryBuilderFormMetricDefinitionBaseComponent ---

	get model(): APIData.CustomQuery.MetricDefinitionValue {
		return this.args.form.metricDefinition!;
	}

	save(data: APIData.CustomQuery.MetricDefinitionValue): void {
		this.args.form.metricDefinition = data;
		once(this, this.queryPreview);
	}

	// ---- end stuff for QueryBuilderFormMetricDefinitionBaseComponent ----
}
